__turbopack_context__.v({
  "BreadcrumbProdutos": "MpwlZq_BreadcrumbProdutos",
  "TituloArea": "MpwlZq_TituloArea",
  "TituloAreaH2": "MpwlZq_TituloAreaH2",
  "TituloAreaH4": "MpwlZq_TituloAreaH4",
  "breadCrumb": "MpwlZq_breadCrumb",
  "breadCrumbExtra": "MpwlZq_breadCrumbExtra",
  "btnVoltar": "MpwlZq_btnVoltar",
  "chamadaArea": "MpwlZq_chamadaArea",
  "dFlex": "MpwlZq_dFlex",
  "uiContainer": "MpwlZq_uiContainer",
  "voltarAssinar": "MpwlZq_voltarAssinar",
});
